export default __webpack_public_path__ + "static/N0299-aeec9228b0c3ccfd416814f24f8deb73.png";